'use client';

import { useState } from 'react';
import { Arrow } from './blog-shared';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Same endpoint, source tag and validation as BlogNewsletterForm (POST /api/waitlist, source 'blog-newsletter'); v2 look. */
export function BlogNewsletterV2({ primary = false }: { primary?: boolean } = {}) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'already' | 'error'>('idle');
  const [msg, setMsg] = useState('');

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const t = email.trim();
    if (!t) { setStatus('error'); setMsg('Please enter your email address.'); return; }
    if (!EMAIL_REGEX.test(t)) { setStatus('error'); setMsg('Please enter a valid email address.'); return; }
    setStatus('loading'); setMsg('');
    try {
      const res = await fetch('/api/waitlist', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: t, source: 'blog-newsletter' }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Subscription failed. Please try again.');
      setStatus(data.alreadyRegistered ? 'already' : 'success');
    } catch (err) {
      setStatus('error'); setMsg(err instanceof Error ? err.message : 'Subscription failed. Please try again.');
    }
  }

  if (status === 'success' || status === 'already') {
    return <p className="bp-nl-m" role="status">{status === 'already' ? "You're already subscribed." : "You're in. Watch your inbox."}</p>;
  }
  return (
    <form className="bp-nl" onSubmit={submit} noValidate>
      <label htmlFor="bp-nl-email" style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}>Email address</label>
      <input id="bp-nl-email" type="email" inputMode="email" autoComplete="email" placeholder="you@yourmortgage.com" value={email} onChange={(e) => setEmail(e.target.value)} aria-invalid={status === 'error'} disabled={status === 'loading'} />
      <button type="submit" className={primary ? 'bp-cta' : 'bp-spec'} disabled={status === 'loading'}><span>{status === 'loading' ? 'Joining...' : 'Subscribe'}</span><Arrow /></button>
      {status === 'error' && <p className="bp-nl-m" role="alert">{msg}</p>}
      <p className="bp-nl-m" style={{ flexBasis: '100%', fontSize: 13, opacity: 0.8 }}>Unsubscribe anytime. <a href="/privacy-policy#notice-at-collection" target="_blank" rel="noopener" style={{ textDecoration: 'underline' }}>Privacy Policy</a></p>
    </form>
  );
}
